import React from "react";
import Theme from "../../components/Theme/Theme";

export default function ThemePage() {
  return (
    <div>
      <Theme></Theme>
    </div>
  );
}
